module.exports = __webpack_public_path__ + "img/3x.9174bf0.jpg";